var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_vm._t("header")],2),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_vm._t("content")],2)])]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('hr'),_vm._v(" "),_vm._t("footer")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a2eabee","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UIComponents/Cards/StatsCard.vue
// module id = UJIc
// module chunks = 6